import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { SendMoneyService } from '../send-money/send-money.service';

@Component({
  selector: 'app-payment-success-qr',
  templateUrl: './payment-success-qr.component.html',
  styleUrls: ['./payment-success-qr.component.scss']
})
export class PaymentSuccessQrComponent implements OnInit {
  amount
  locations = []
  selectedLocation
  markers = []
  previous
  postalCode
  lastPage
  currentPage = 1
  show = false
  constructor(public sendMoneyService : SendMoneyService, private common : CommonService) { }
  lat: number 
  lng: number 
 
  ngOnInit(): void {
    this.amount = this.sendMoneyService.qr_amount
    this.locations =  this.sendMoneyService.ps_locations
    this.setupMap() 
  }

  setupMap(){
    // this.selectedLocation = this.locations[0]
    if(this.locations?.length){
      this.markers = []
      this.locations.forEach((location,i) => {
        this.markers.push({
          lat : location.latitude,
          lng : location.longitude,
          draggable: false,
          label : i,
          title : location.location_name
        })
      });
      this.lat = +this.locations[0].latitude
      this.lng = +this.locations[0].longitude
    }
    else{
      this.show = true
    }
  }

  assignCoordinates(lat, lon, location){
    this.markers = []
    this.selectedLocation = location
    this.lat = +lat
    this.lng =  +lon
    this.markers.push({
      lat : location.latitude,
      lng : location.longitude,
      draggable: false,
      // label : i,
      title : location.location_name
    })
  }

  clickedMarker(infowindow) {
    if (this.previous && this.markers.length>1) {
        this.previous.close();
    }
    this.previous = infowindow;
  }

 getLocationByPostal(){
   this.common.showLoader()
    this.sendMoneyService.getLocationByPostalCode(this.postalCode, 1).subscribe((res:any) => {
      this.lastPage = res.data.last_page
      this.locations = res.data.data
      this.setupMap()
      this.common.stopLoader()
    }, err => {
      this.show = true
      this.common.stopLoader()

  })
 }

 nextPage(){
   if(this.lastPage != this.currentPage){
     this.common.showLoader()
      this.currentPage += 1
      this.sendMoneyService.getLocationByPostalCode(this.postalCode || this.sendMoneyService.auth.user.zip_code, this.currentPage).subscribe((res:any) => {
        this.lastPage = res.data.last_page
        this.locations = res.data.data
        this.setupMap()
        this.common.stopLoader()
      }, err => {
          this.show = true
          this.common.stopLoader()
      })
    }
    
  }
 
  
  prevPage(){
    if(this.currentPage != 1){
      this.common.showLoader()
      this.currentPage -= 1
      this.sendMoneyService.getLocationByPostalCode(this.postalCode || this.sendMoneyService.auth.user.zip_code, this.currentPage).subscribe((res:any) => {
        this.lastPage = res.data.last_page
        this.locations = res.data.data
        this.setupMap()
        this.common.stopLoader()
      }, err => {
          this.show = true
          this.common.stopLoader()
      })
    }
  }

  checkDisabled(type){
    if(type=='prev'){
      return this.currentPage == 1 ? true : false
    }
    else if( type == 'next'){
      return this.currentPage == this.lastPage ? true : false
    }
  }
}
